/* eslint-disable default-case */
import styled, { css } from "styled-components";
import React, { useState, useEffect } from "react";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { useAirtable } from "../hooks/useAirtable";
import { useIframe } from "../hooks/useIframe";
import { useMediaQuery } from "react-responsive";

export const RegisterFormGroup = ({
  url,
  mode,
  category,
  name,
  password,
  phoneNumber,
  domain,
}) => {
  const [dataState, setDataState] = useState({});
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [formFields, setFormFields] = useState([]);
  const [participant, setParticipant] = useState([]);
  const [newParticipants, setNewParticipants] = useState([]);
  const [title, setTitle] = useState("개인참가신청");
  const [loading, setLoading] = useState(true);
  const [editableRow, setEditableRow] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 820 });
  const {
    fetchData,
    updateData,
    createData,
    fetchParticipantData,
    updateParticipantData,
    createParticipantData,
  } = useAirtable(category);
  const { setMoveUrl } = useIframe(domain);

  const [dataId, setDataId] = useState("");
  const open = useDaumPostcodePopup();

  const genderOptions = ["남자", "여자"];
  const eventOptions = ["5km", "10km", "하프"];
  const giftOptions = ["80", "85", "90", "95", "100", "105", "110"];

  useEffect(() => {
    setTitle(
      category === "individual"
        ? "개인참가신청"
        : category === "group"
        ? "단체전참가신청"
        : category === "club"
        ? "대항전참가신청"
        : "개인참가신청"
    );
  }, []);

  useEffect(() => {
    let fields = [];
    // eslint-disable-next-line default-case
    switch (category) {
      case "group":
        fields = [
          {
            type: "text",
            name: "name",
            required: true,
            label: "딘체명",
            note: "※ 단체명이 없거나 가족일경우 ㅇㅇㅇ일행(가족)으로 기재해주십시오",
            placeholder: "단체명",
          },
          {
            type: "text",
            name: "representativeName",
            required: true,
            label: "대표자명",
            note: "※ 실명으로 입력, 띄어쓰기 금지",
            placeholder: "대표자명",
          },
          {
            type: "tel",
            name: "phoneNumber",
            required: true,
            label: "휴대폰",
            placeholder: "010-0000-0000",
            note: "※ 연락 가능한 번호를 꼭 입력해주세요",
          },
          {
            type: "text",
            name: "postalCode",
            required: true,
            label: "주소",
          },
          { type: "text", name: "address", required: true, label: "주소" },
          {
            type: "text",
            name: "detailedAddress",
            required: true,
            label: "상세주소",
          },
          {
            type: "email",
            name: "email",
            required: false,
            label: "이메일",
            placeholder: "이메일을 입력해주세요",
          },
          {
            type: "text",
            name: "deposit",
            required: true,
            label: "입금자명",
          },
          {
            type: "password",
            name: "password",
            required: true,
            label: "비밀번호",
            note: "※ 조회, 수정 시 필요합니다",
          },
        ];
        break;
      case "club":
        fields = [
          {
            type: "text",
            name: "name",
            required: true,
            label: "딘체명",
            note: "※ 단체명이 없거나 가족일경우 ㅇㅇㅇ일행(가족)으로 기재해주십시오",
            placeholder: "단체명",
          },
          {
            type: "text",
            name: "representativeName",
            required: true,
            label: "대표자명",
            note: "※ 실명으로 입력, 띄어쓰기 금지",
            placeholder: "대표자명",
          },
          {
            type: "tel",
            name: "phoneNumber",
            required: true,
            label: "휴대폰",
            placeholder: "010-0000-0000",
            note: "※ 연락 가능한 번호를 꼭 입력해주세요",
          },
          {
            type: "text",
            name: "postalCode",
            required: true,
            label: "주소",
          },
          { type: "text", name: "address", required: true, label: "주소" },
          {
            type: "text",
            name: "detailedAddress",
            required: true,
            label: "상세주소",
          },
          {
            type: "text",
            name: "reference",
            required: false,
            label: "침고항목",
          },
          {
            type: "email",
            name: "email",
            required: false,
            label: "이메일",
            placeholder: "이메일을 입력해주세요",
          },
          {
            type: "text",
            name: "deposit",
            required: true,
            label: "입금자명",
          },
          {
            type: "password",
            name: "password",
            required: true,
            label: "비밀번호",
            note: "※ 조회, 수정 시 필요합니다",
          },
        ];
        break;
    }
    setFormFields(fields);
  }, [category]);

  useEffect(() => {
    const fetchDataAndSetData = async () => {
      const { fields, id } = await fetchData(
        `AND({name}="${name}", {password}="${password}", {phoneNumber}="${phoneNumber}")`
      );

      // console.log(fields, "fields", id, "id");

      if (fields) {
        setDataState(fields);
        setDataId(id);
        const participantNameList = [...fields.members];

        const newParticipantObject = [];

        for (const recordId of participantNameList) {
          const { fields: participantFields, id: participantId } =
            await fetchParticipantData(`${category}Participant`, recordId);

          if (participantFields) {
            // Add the id to the participantFields object under the key 'uuid'
            participantFields.uuid = participantId;

            newParticipantObject.push(participantFields);
            setParticipant((prev) => [...prev, participantFields]);
          }
        }
      } else {
        let path =
          category === "individual"
            ? "indiv"
            : category === "group"
            ? "team"
            : category === "club"
            ? "competition"
            : "indiv";
        alert("죄송합니다, 잘못된 접근입니다.\n이전 페이지로 돌아갑니다.");
        setMoveUrl(`${domain}/${path}-check`);
      }
    };

    if (mode === "edit") {
      fetchDataAndSetData();
      setCheckDuplicate(true);
    } else {
      setDataState({});
      for (let i of [1, 2]) {
        const newEntry = {
          id: i,
          name: "",
          birthdate: "",
          event: "10km",
          gender: "여자",
          gift: "85",
          phoneNumber: "",
          address: "",
        };

        setNewParticipants((prevState) => [...prevState, newEntry]);
      }
    }
    setLoading(false);
  }, [mode]);

  // useEffect(() => {
  //   console.log("dataState: ", dataState);
  // }, [dataState]);

  async function checkDuplicateClubName() {
    if (!dataState.name || (dataState.name && dataState.name === "")) {
      alert("단체명을 입력해주세요");
      return;
    }

    if (dataState.name === name) {
      setCheckDuplicate(true);
      return;
    }
    const response = await fetchData(`AND({name}="${dataState.name}")`);
    if (response.fields) {
      alert("중복된 단체명입니다. 다른 이름을 입력해주세요");
      setDataState({ ...dataState, name: "" });
      return;
    }
    alert("사용가능한 단체명입니다. 나머지 항목을 채워주세요.");
    setCheckDuplicate(true);
  }

  const handleInputChange = (event) => {
    let { name, value } = event.target;
    if (name === "phoneNumber") {
      value = formatPhoneNumber(value);
    }

    setDataState((prevState) => ({ ...prevState, [name]: value }));
    if (name === "name") {
      setCheckDuplicate(false);
    }
  };

  const formatPhoneNumber = (value) => {
    const MAX_PHONE_LENGTH = 13; // "XXX-XXXX-XXXX" is 13 characters

    // Step 1: Remove any non-digit characters
    const numbers = value.replace(/[^\d]/g, "");

    // Step 2: Take the first 11 digits (if there are more)
    const trimmedNumbers = numbers.slice(0, 11);

    // Step 3: Divide the number string into 3-4-4
    const match = trimmedNumbers.match(/^(\d{3})(\d{4})(\d{4})$/);

    if (match) {
      const formattedNumber = `${match[1]}-${match[2]}-${match[3]}`;
      return formattedNumber.slice(0, MAX_PHONE_LENGTH); // ensure that the final string doesn't exceed the maximum length
    }

    return value; // if it doesn't match the pattern, return the original value
  };

  const checkRequiredFields = () => {
    const requiredFields = formFields
      .filter((field) => field.required)
      .map((field) => field.name);
    const isValid = requiredFields.every((name) => {
      if (dataState[name]) {
        return dataState[name].trim() !== "";
      }
      return false;
    });

    setIsValid(isValid);
  };

  const handleDaumComplete = (data) => {
    setDataState((prevState) => ({
      ...prevState,
      postalCode: data.zonecode,
      address: data.roadAddress,
      detailedAddress: "",
    }));

    // console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  };

  const handleDaumClick = () => {
    open({ onComplete: handleDaumComplete });
  };

  const handleCancelClick = () => {
    setMoveUrl(`${domain}`);
  };

  const handleSubmit = async () => {
    const requiredFields = [
      "name",
      "representativeName",
      "phoneNumber",
      "address",
      "postalCode",
      "detailedAddress",
      "email",
      "deposit",
      "password",
    ];
    if (isValid && checkDuplicate) {
      await sendSlackMessage(`Clicked from ${url}`);
      // Ensure that category is present before making any operation
      if (!category) {
        // console.error("Category is missing!");
        return;
      }

      if (loading) {
        // alert("현재 신청서를 제출입니다. 잠시만 기다려주세요🙏");
        return;
      }

      try {
        let responseData;
        setLoading(true);
        if (mode === "apply") {
          if (category === "club") {
            requiredFields.push("reference");
          }
          const allMembersValid = newParticipants.every(isInputValid);

          if (!allMembersValid) {
            alert("제출하기 전에 모든 팀원을 꼼꼼히 채워주세요.");
            setLoading(false);
            return; // Stop the function execution
          }

          const newData = extractRelevantFields(dataState, requiredFields);
          responseData = await createData(newData);
          console.log("responseData", responseData);
          // New logic to handle newParticipants when mode is "apply"
          for (let item of newParticipants) {
            const requiredFields = [
              "name",
              "birthdate",
              "event",
              "gender",
              "gift",
              "phoneNumber",
              "address",
            ];
            const memberData = extractRelevantFields(item, requiredFields);
            // console.log("memberData: ", memberData);
            memberData.group = [responseData.id]; // Use the ID from the created data
            await createMember(category, memberData);
          }

          setNewParticipants([]); // Clear out newParticipants after saving them
        } else if (mode === "edit") {
          // Ensure recordId is present for "edit" mode
          if (!dataId) {
            console.error("recordId is missing for edit mode!");
            setLoading(false);
            return;
          }

          // Using updateData for "edit" mode
          const newData = extractRelevantFields(dataState, requiredFields); // Extracting the relevant fields
          responseData = await updateData(dataId, newData); // Creating the new member
          console.log("Data successfully updated!", responseData);
        } else {
          throw new Error("Invalid mode provided");
        }
        setLoading(false);
        setMoveUrl(`${domain}`);

        // Handle successful operation, e.g.:
        // Show a success message, or redirect the user to another page.
      } catch (error) {
        console.error("Failed to process data:", error);
        const message = `현재 네트워크 접속상태가 좋지 않습니다.\n\n스마트폰 등 모바일 기기로 재신청 부탁드립니다.\n\n모바일에서도 동일한 에러가 발생한다면 개발지원팀(010-8793-8337) 으로 문의주시면 감사하겠습니다.`;

        alert(message);
        await sendSlackMessage(
          `FAILED! An error occurred from ${url}\n\n${error}`
        );
      }
    } else if (!isValid) {
      alert("제출하기 전에 모든 항목을 꼼꼼히 채워주세요.");
    } else if (!checkDuplicate) {
      alert("클럽 이름을 중복 확인해주세요.");
    }
  };

  const sendSlackMessage = async (message = "user trying submission") => {
    const userAgent = navigator.userAgent;
    const slackMessage = {
      text: `📌  ${message}\n\n${JSON.stringify(dataState)}\n\n${userAgent}`,
    };

    const url = `https://hooks.zapier.com/hooks/catch/16380552/35grui9/`;

    const data = {
      text: slackMessage,
    };

    fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
    });
  };

  const handleInputChangeMember = (id, fieldName, value) => {
    // Check if the ID exists in newParticipants
    if (fieldName === "phoneNumber") {
      value = formatPhoneNumber(value);
    }

    const isNewParticipant = newParticipants.some((item) => item.id === id);

    if (isNewParticipant) {
      // If the member is a new participant, update the newParticipants state
      const updatedNewParticipants = newParticipants.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [fieldName]: value,
          };
        }
        return item;
      });
      setNewParticipants(updatedNewParticipants);
    } else {
      // If the member is an existing participant, update the participant state
      const updatedParticipants = participant.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [fieldName]: value,
          };
        }
        return item;
      });
      setParticipant(updatedParticipants);
    }
  };

  const handleEditToggle = (id) => {
    const isCurrentlyEditable = editableRow.includes(id);

    if (isCurrentlyEditable) {
      setEditableRow((prevRows) => prevRows.filter((rowId) => rowId !== id));
    } else {
      setEditableRow((prevRows) => [...prevRows, id]);
    }
  };

  const handleAddMember = () => {
    const totalParticipants = participant.length + newParticipants.length;

    if (category === "club" && totalParticipants >= 6) {
      alert(
        "더이상 추가할 수 없습니다. 참가자는 최대 6명까지만 등록 가능합니다."
      );
      return;
    }

    const newEntry = {
      id: totalParticipants + 1,
      name: "",
      birthdate: "",
      event: "10km",
      gender: "여자",
      gift: "85",
      phoneNumber: "",
      address: "",
    };

    setNewParticipants((prevState) => [...prevState, newEntry]);
  };

  const isRowEditable = (item) => {
    return newParticipants.includes(item) || editableRow.includes(item.id);
  };

  const isInputValid = (item) => {
    // Check if all the fields are present and not empty
    const requiredFields = [
      "name",
      "birthdate",
      "event",
      "gender",
      "gift",
      "phoneNumber",
      "address",
    ];
    return requiredFields.every(
      (field) => item[field] && item[field].trim() !== ""
    );
  };

  const updateMember = async (category, dataId, dataState) => {
    // Directly update the member's data using the provided dataState
    await updateParticipantData(`${category}Participant`, dataId, dataState);

    // Provide feedback on completion
    console.log(`Member with ID ${dataId} updated successfully!`);
  };

  const createMember = async (category, dataState) => {
    // Step 1: Create the new member's data using the provided dataState
    const newMember = await createParticipantData(
      `${category}Participant`,
      dataState
    );

    // Step 2: Provide feedback on completion
    console.log(`New member created successfully with ID: ${newMember.id}`);

    // Step 3: Return the new member for any further processing
    return newMember;
  };

  const extractRelevantFields = (item, requiredFields) => {
    let extractedData = {};
    requiredFields.forEach((field) => {
      extractedData[field] = item[field];
    });
    return extractedData;
  };

  const handleCompleteMember = async (item) => {
    const requiredFields = [
      "birthdate",
      "event",
      "gender",
      "gift",
      "name",
      "phoneNumber",
      "address",
    ];
    if (isInputValid(item)) {
      if (loading) {
        alert("현재 정보를 수정중입니다. 잠시만 기다려주세요🙏");
        return;
      }
      setLoading(true);
      if (mode === "apply") {
        // state만 저장
      } else if (mode === "edit") {
        if (newParticipants.includes(item)) {
          // 새로 생성
          const newData = extractRelevantFields(item, requiredFields); // Extracting the relevant fields
          newData.group = [dataId];
          const createdMember = await createMember(category, newData); // Creating the new member

          // Step 1: Add the newly created member to the `participant` state
          setParticipant((prev) => [...prev, createdMember.fields]);

          // Step 2: Remove the member from `newParticipants` after creating it
          setNewParticipants((prev) => prev.filter((entry) => entry !== item));
        } else {
          // 업데이트
          const updateData = extractRelevantFields(item, requiredFields);
          updateData.group = [dataId];
          await updateMember(category, item.uuid, updateData);
        }
      }
      handleEditToggle(item.id); // To toggle off the editing mode
      setLoading(false);
    } else {
      alert("제출하기 전에 모든 항목을 꼼꼼히 채워주세요.");
    }
  };

  useEffect(() => {
    checkRequiredFields();
  }, [dataState]);

  return (
    <Container ismobile={isMobile}>
      <Title ismobile={isMobile}>{title}</Title>
      {category === "club" && (
        <>
          <div
            style={{
              color: "#FF791A",
              fontWeight: "bold",
              marginTop: 50,
              marginBottom: 30,
            }}
          >
            ※ 대항전 신청 자격
          </div>
          <InfoTableContainer>
            <Table>
              <InfoTableRow>
                <InfoTableCell flex="2">남자 30대</InfoTableCell>
                <InfoTableCell flex="4">
                  ( 1984년 1월 1일 ~ 1993년 12월 31일생 )
                </InfoTableCell>
                <InfoTableCell flex="1">1명</InfoTableCell>
              </InfoTableRow>
              <InfoTableRow>
                <InfoTableCell flex="2">남자 40대</InfoTableCell>
                <InfoTableCell flex="4">
                  (1974년 1월 1일 ~ 1983년 12월 31일생 )
                </InfoTableCell>
                <InfoTableCell flex="1">2명</InfoTableCell>
              </InfoTableRow>
              <InfoTableRow>
                <InfoTableCell flex="2">남자 50대</InfoTableCell>
                <InfoTableCell flex="4">
                  (1973년 12월 31일 이전 출생자 )
                </InfoTableCell>
                <InfoTableCell flex="1">2명</InfoTableCell>
              </InfoTableRow>
              <InfoTableRow>
                <InfoTableCell flex="2">여자 20대 이상</InfoTableCell>
                <InfoTableCell flex="4">
                  (2003년 12월 31일 이전 출생자 )
                </InfoTableCell>
                <InfoTableCell flex="1">1명</InfoTableCell>
              </InfoTableRow>
            </Table>
          </InfoTableContainer>
        </>
      )}
      <FormContainer>
        {formFields.map((field) => {
          // console.log(field, "field");
          if (field.name === "detailedAddress" || field.name === "address") {
            return null;
          }

          if (field.name === "category") {
            return;
          }

          if (field.name === "name") {
            return (
              <FormWrapper key={field.name} ismobile={isMobile}>
                <FormKey ismobile={isMobile}>
                  {field.label}
                  {field.required && <b>*</b>}
                </FormKey>
                <ClubNameWrapper id="value" ismobile={isMobile}>
                  <input
                    type={field.type}
                    name={field.name}
                    required={field.required}
                    value={dataState[field.name] || ""}
                    onChange={handleInputChange}
                    placeholder={field.placeholder || ""}
                  />
                  <input
                    type="button"
                    value={checkDuplicate ? "확인 완료" : "중복 확인"}
                    onClick={checkDuplicateClubName}
                  />
                  {field.note && <span>{field.note}</span>}
                </ClubNameWrapper>
              </FormWrapper>
            );
          }

          return (
            <FormWrapper key={field.name} ismobile={isMobile}>
              <FormKey ismobile={isMobile}>
                {field.label}
                {field.required && <b>*</b>}
              </FormKey>
              <div id="value">
                {field.type === "radio" ? (
                  field.options.map((option) => (
                    <label key={option}>
                      <input
                        type={field.type}
                        name={field.name}
                        value={option}
                        required={field.required}
                        checked={dataState[field.name] === option}
                        onChange={handleInputChange}
                      />
                      {option}
                    </label>
                  ))
                ) : field.name === "postalCode" ? (
                  <AddressWrapper ismobile={isMobile}>
                    <div>
                      <input
                        type={field.type}
                        name="postalCode"
                        id="postalCode"
                        placeholder="우편번호"
                        value={dataState[field.name] || ""}
                        readOnly
                        required
                      />
                      <input
                        type="button"
                        value="우편번호 찾기"
                        onClick={handleDaumClick}
                      />
                    </div>
                    <input
                      type="text"
                      name="address"
                      id="address"
                      placeholder="주소"
                      value={dataState["address"] || ""}
                      readOnly
                      required
                    />
                    <input
                      type="text"
                      name="detailedAddress"
                      id="detailAddress"
                      placeholder="상세주소"
                      value={dataState["detailedAddress"] || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </AddressWrapper>
                ) : (
                  <input
                    type={field.type}
                    name={field.name}
                    required={field.required}
                    value={dataState[field.name] || ""}
                    onChange={handleInputChange}
                    placeholder={field.placeholder || ""}
                  />
                )}
                {field.note && <span>{field.note}</span>}
              </div>
            </FormWrapper>
          );
        })}
      </FormContainer>

      {/* <FormContainer>

      </FormContainer> */}

      <GroupContainer>
        <EditToolWrapper>
          <EditInfo>※ 생년월일, 종목 변경은 사무국으로 연락 바랍니다</EditInfo>
          <GrayButton onClick={handleAddMember}>추가등록 +</GrayButton>
        </EditToolWrapper>
        <TableContainer>
          <Table>
            <TableRow>
              <TableCell flex="1">NO</TableCell>
              <TableCell flex="3">성명</TableCell>
              <TableCell flex="4">생년월일</TableCell>
              <TableCell flex="3">성별</TableCell>
              <TableCell flex="3">참가종목</TableCell>
              <TableCell flex="3">기념품</TableCell>
              <TableCell flex="4">연락처</TableCell>
              <TableCell flex="4">주소</TableCell>
              {mode === "edit" && (
                <>
                  {/* <TableCell flex="2">입금</TableCell> */}
                  <TableCell flex="2">수정</TableCell>
                </>
              )}
            </TableRow>
            {participant &&
              [...participant, ...newParticipants].map((item, index) => {
                const isEditable = isRowEditable(item);
                return (
                  <TableRow>
                    <TableCell flex="1">{index + 1}</TableCell>
                    <TableCell flex="3">
                      {isEditable ? (
                        <input
                          type="text"
                          name="name"
                          required={true}
                          value={item.name || ""}
                          onChange={(e) =>
                            handleInputChangeMember(
                              item.id,
                              "name",
                              e.target.value
                            )
                          }
                          placeholder="성명"
                          readOnly={!isEditable}
                        />
                      ) : (
                        item.name
                      )}
                    </TableCell>
                    <TableCell flex="4">
                      {isEditable ? (
                        <input
                          type="date"
                          name="birthdate"
                          required={true}
                          value={item.birthdate || ""}
                          onChange={(e) =>
                            handleInputChangeMember(
                              item.id,
                              "birthdate",
                              e.target.value
                            )
                          }
                          readOnly={!isEditable}
                        />
                      ) : (
                        item.birthdate
                      )}
                    </TableCell>
                    <TableCell flex="3">
                      {isEditable ? (
                        <select
                          value={item.gender}
                          name="gender"
                          onChange={(e) =>
                            handleInputChangeMember(
                              item.id,
                              "gender",
                              e.target.value
                            )
                          }
                        >
                          {genderOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      ) : (
                        item.gender
                      )}
                    </TableCell>

                    <TableCell flex="3">
                      {isEditable ? (
                        <select
                          value={item.event}
                          name="event"
                          onChange={(e) =>
                            handleInputChangeMember(
                              item.id,
                              "event",
                              e.target.value
                            )
                          }
                        >
                          {eventOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      ) : (
                        item.event
                      )}
                    </TableCell>

                    <TableCell flex="3">
                      {isEditable ? (
                        <select
                          name="gift"
                          value={item.gift}
                          onChange={(e) =>
                            handleInputChangeMember(
                              item.id,
                              "gift",
                              e.target.value
                            )
                          }
                        >
                          {giftOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      ) : (
                        item.gift
                      )}
                    </TableCell>

                    <TableCell flex="4">
                      {isEditable ? (
                        <input
                          type="tel"
                          name="phoneNumber"
                          required={true}
                          value={item.phoneNumber || ""}
                          onChange={(e) =>
                            handleInputChangeMember(
                              item.id,
                              "phoneNumber",
                              e.target.value
                            )
                          }
                          placeholder="01000000000"
                          readOnly={!isEditable}
                        />
                      ) : (
                        item.phoneNumber
                      )}
                    </TableCell>
                    <TableCell flex="4">
                      {isEditable ? (
                        <input
                          type="text"
                          name="address"
                          required={true}
                          value={item.address || ""}
                          onChange={(e) =>
                            handleInputChangeMember(
                              item.id,
                              "address",
                              e.target.value
                            )
                          }
                          placeholder="주소를 입력해주세요."
                          readOnly={!isEditable}
                        />
                      ) : (
                        item.address
                      )}
                    </TableCell>
                    {mode === "edit" && (
                      <>
                        {/* <TableCell flex="2">{item.deposit}</TableCell> */}
                        <TableCell flex="2">
                          <GrayButton
                            onClick={() =>
                              isEditable
                                ? handleCompleteMember(item)
                                : handleEditToggle(item.id)
                            }
                            disabled={loading}
                          >
                            {isEditable ? "완료" : "수정"}
                          </GrayButton>
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                );
              })}
          </Table>
        </TableContainer>
      </GroupContainer>

      <BtnContainer>
        <FormBtn type="button" onClick={handleCancelClick}>
          취소
        </FormBtn>
        <FormBtn
          id="submitButton"
          type="submit"
          onClick={handleSubmit}
          primary={isValid}
          disabled={!isValid || loading || !checkDuplicate ? true : false}
        >
          {mode === "apply" ? "신청하기" : "수정하기"}{" "}
          <i className="bi bi-arrow-right-circle-fill"></i>
        </FormBtn>
      </BtnContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: ${(props) => (props.ismobile ? "90%" : "82%")};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 5rem 0;
  position: relative;
`;

const FormContainer = styled.div`
  overflow: hidden;
  border-radius: 15px;
  border: 1.5px solid #d9d9d9;
  width: 100%;
  display: flex;
  flex-direction: column;

  & > div {
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1.5px solid #d9d9d9;
    padding: 3.5rem;
    box-sizing: border-box;

    &:last-child {
      border-bottom: 0;
    }
  }
`;

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: ${(props) => (props.ismobile ? "1rem" : "3.5rem")};
  input[type="text"],
  input[type="tel"],
  input[type="date"],
  input[type="email"],
  input[type="password"] {
    color: #555;
    font-family: "Nanum Gothic", sans-serif;
    width: ${(props) => (props.ismobile ? "80%" : "30rem")};
    border: 1.2px solid #d9d9d9;
    margin-left: ${(props) => (props.ismobile ? "1rem" : "2rem")};
    padding: ${(props) => (props.ismobile ? "0.8rem" : "1.4rem")};
    font-size: ${(props) => (props.ismobile ? "1.2rem" : "1.5rem")};
  }
  input[type="radio"] {
    margin-left: 2rem;
  }
  &:last-child {
    border-bottom: 0;
  }

  & > #value {
    display: flex;
    flex-wrap: wrap;
    flex-direction: ${(props) => (props.ismobile ? "column" : "row")};
  }
  span {
    margin-left: ${(props) => (props.ismobile ? "1rem" : "2rem")};
    color: #555;
    font-size: ${(props) => (props.ismobile ? "1.0rem" : "1.3rem")};
    line-height: 100%;
    letter-spacing: ${(props) => (props.ismobile ? "0" : "-0.2px")};
    margin-top: ${(props) => (props.ismobile ? "1rem" : 0)};
  }
`;

const FormKey = styled.div`
  width: ${(props) => (props.ismobile ? "30%" : "20%")};
  height: 100%;
  display: flex;
  align-items: center;
  font-size: ${(props) => (props.ismobile ? "1.5rem" : "1.7rem")};
  font-style: normal;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.2px;
  border-right: 1px solid #d9d9d9;
  flex-shrink: 0;
  & > b {
    color: #d10000;
  }
`;

const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;

  & input[type="button"] {
    padding: ${(props) => (props.ismobile ? "1.0rem" : "1.4rem")};
    border: 1.2px solid #d9d9d9;
    background: #d9d9d9;
    color: #4f4f4f;
    font-size: ${(props) => (props.ismobile ? "1.2rem" : "1.5rem")};
    font-weight: 700;
    letter-spacing: -0.2px;
    cursor: pointer;
    margin-left: 1rem;
    margin-top: ${(props) => (props.ismobile ? "0.7rem" : 0)};
  }

  & input[type="text"]:first-child {
    width: ${(props) => (props.ismobile ? "80%" : "30rem")};
  }

  & input[type="text"] {
    width: 100%;
    font-size: ${(props) => (props.ismobile ? "1.2rem" : "1.5rem")};
  }
`;

const ClubNameWrapper = styled.div`
  & input[type="button"] {
    padding: ${(props) => (props.ismobile ? "1.0rem" : "1.4rem")};
    border: 1.2px solid #d9d9d9;
    background: #d9d9d9;
    color: #4f4f4f;
    width: ${(props) => (props.ismobile ? "50%" : "auto")};
    font-size: ${(props) => (props.ismobile ? "1.2rem" : "1.5rem")};
    font-weight: 700;
    letter-spacing: ${(props) => (props.ismobile ? 0 : "-0.2px")};
    cursor: pointer;
    margin-top: 0.7rem;
    margin-left: 1rem;
  }
`;

const GroupContainer = styled.div`
  margin-top: 6rem;
`;

const EditToolWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
`;

const EditInfo = styled.div`
  color: #d10000;
  font-size: 1.7rem;
  font-style: normal;
  font-weight: 800;
  line-height: 100%; /* 17px */
  letter-spacing: -0.02rem;
`;

const GrayButton = styled.button`
  padding: 1.4rem;
  border: 1.2px solid #d9d9d9;
  background: #d9d9d9;
  color: #4f4f4f;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.2px;
  cursor: pointer;
  font-size: 1rem;
`;

const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-top: 3.5rem;
`;
const FormBtn = styled.div`
  width: 50%;
  padding: 2rem;
  font-size: 1.9rem;
  font-weight: 700;
  background: #fff;
  border-radius: 100px 100px 100px 0px;
  border: 1.5px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 0 auto;
  cursor: pointer;
  ${(props) =>
    props.primary &&
    css`
      background: #ff791a;
      color: #fff;
    `}
`;

const TableContainer = styled.div`
  width: 100%;
  overflow: scroll;
  border-radius: 15px;
  border: 1.5px solid #d9d9d9;
`;

const InfoTableContainer = styled.div`
  width: 70%;
  border-radius: 15px;
  border: 1.5px solid #d9d9d9;
  margin-bottom: 50px;
`;

const InfoTableCell = styled.div`
  flex: ${(props) => props.flex || "1"};
  font-size: 1.4rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
  &:not(:last-child) {
    border-right: 1.5px solid #d9d9d9;
  }
`;

const InfoTableRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 60px;
  border-bottom: 1.5px solid #d9d9d9;
  & > div:last-child {
    border-right: 0px solid #d9d9d9;
  }
  &:last-of-type {
    border-bottom: 0;
  }
`;

const TableCell = styled.div`
  flex: ${(props) => props.flex || "1"};
  font-size: 1.3rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
  &:not(:last-child) {
    border-right: 1.5px solid #d9d9d9;
  }
  input[type="tel"],
  input[type="date"] {
    color: #555;
    font-family: "Nanum Gothic", sans-serif;
    width: 10rem;
    border: 1.2px solid #d9d9d9;
    padding: 1.4rem;
    font-size: 1.2rem;
  }
  input[type="text"] {
    color: #555;
    font-family: "Nanum Gothic", sans-serif;
    width: 8rem;
    border: 1.2px solid #d9d9d9;
    padding: 1.4rem;
    font-size: 1.2rem;
  }
  select {
    color: #555;
    font-family: "Nanum Gothic", sans-serif;
    width: 8rem;
    border: 1.2px solid #d9d9d9;
    padding: 1.2rem;
    background: #fff;
    cursor: pointer;
    font-size: 1.2rem;
  }

  option {
    font-family: "Nanum Gothic", sans-serif;
    padding: 1rem;
    background: #fff;
    border: none;
    cursor: pointer;
  }
`;

const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 80px;
  border-bottom: 1.5px solid #d9d9d9;
  & > div:last-child {
    border-right: 0px solid #d9d9d9;
  }
  &:first-of-type {
    background: #fff9ef;
  }
  &:last-of-type {
    border-bottom: 0;
  }
`;

const Table = styled.div`
  display: flex;
  /* overflow: hidden; */
  flex-direction: column;
  width: 100%;

  input[type="tel"],
  input[type="date"] {
    color: #555;
    font-family: "Nanum Gothic", sans-serif;
    width: 10rem;
    border: 1.2px solid #d9d9d9;
    padding: 1.4rem;
  }
  input[type="text"],
  input[type="email"],
  input[type="password"] {
    color: #555;
    font-family: "Nanum Gothic", sans-serif;
    width: 8rem;
    border: 1.2px solid #d9d9d9;
    padding: 1.4rem;
  }
  input[type="radio"] {
    margin-left: 2rem;
  }
  select {
    color: #555;
    font-family: "Nanum Gothic", sans-serif;
    width: 8rem;
    border: 1.2px solid #d9d9d9;
    padding: 1.2rem;
    background: #fff; /* White background to keep it consistent. */
    cursor: pointer; /* Change the cursor to indicate it's selectable. */
  }

  option {
    font-family: "Nanum Gothic", sans-serif;
    padding: 1rem;
    background: #fff; /* White background for options. */
    border: none; /* Removing any default browser style. */
    cursor: pointer; /* Change the cursor to indicate it's selectable. */
  }
`;

const Title = styled.div`
  color: #555;
  font-family: "Jalnan", sans-serif;
  font-size: ${(props) => (props.ismobile ? "3rem" : "4rem")};
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  margin: 0 0 2rem;
  letter-spacing: -0.8px;
  & b {
    color: #ff791a;
  }
`;
